'use client';

import { Icon } from '@/components/icons/svg-icons';
import { Button } from '@base-ui/react/button';
import clsx from 'clsx';
import styles from './wc-promotion-button.module.scss';

export type WcPromotionButtonVariant = 'primary' | 'outline';

const BUTTON_TYPE: Record<WcPromotionButtonVariant, string> = {
	primary: styles.primary,
	outline: styles.outline
};

export interface WcPromotionButtonProps {
	label: string;
	iconName?: string;
	variant?: WcPromotionButtonVariant;
	disabled?: boolean;
	onClick?: () => void;
	className?: string;
}

export const WcPromotionButton = ({
	label,
	iconName,
	variant = 'primary',
	disabled = false,
	onClick,
	className
}: WcPromotionButtonProps) => (
	<Button
		type="button"
		disabled={disabled}
		className={clsx(styles.root, BUTTON_TYPE[variant], className)}
		onClick={onClick}
	>
		{label}
		{iconName ? <Icon name={iconName} /> : null}
	</Button>
);
